import { render, staticRenderFns } from "./D2-pie.vue?vue&type=template&id=19cb6678&scoped=true"
import script from "./D2-pie.vue?vue&type=script&lang=js"
export * from "./D2-pie.vue?vue&type=script&lang=js"
import style0 from "./D2-pie.vue?vue&type=style&index=0&id=19cb6678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb6678",
  null
  
)

export default component.exports